<template>
  <component
    :is="CategoriesPage"
    v-if="matchedType === 'Categories'"
    :categories="categories"
    :loading="loadingCategories"
  />
  <component
    :is="ContentPage"
    v-else-if="matchedType === 'Content'"
    :content="content"
    :loading="loadingContent"
  />
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent, watchEffect } from 'vue'
import { useRoute } from 'vue-router'

import { usePageStore } from '@/store/page'
import { useCategoriesBySlug } from '@/api/useCategories'
import { useContentBySlug } from '@/api/useContent'

const route = useRoute()
const { page } = usePageStore()

const detail = route.params.detail as string

const { categories, fetchCategories, loading: loadingCategories } = useCategoriesBySlug(detail)
const { content, fetchContent, loading: loadingContent } = useContentBySlug(detail)

const matchedType = ref<null | 'Categories' | 'Content'>(null)

if (page.type === 'category') {
  fetchCategories().then(() => {})
  matchedType.value = 'Categories'
} else if (page.type === 'content') {
  fetchContent().then(() => {})
  matchedType.value = 'Content'
} else {
  fetchCategories().then(() => {})
  fetchContent().then(() => {})
  watchEffect(() => {
    if (!loadingCategories.value && categories.value) {
      matchedType.value = 'Categories'
    } else if (!loadingContent.value && content.value) {
      matchedType.value = 'Content'
    } else if (!loadingCategories.value && !loadingContent.value) {
      showError({
        statusCode: 404,
      })
    }
  })
}

page.type = null

const CategoriesPage = defineAsyncComponent(() => import('@/pages/categories/[detail]/index.vue'))
const ContentPage = defineAsyncComponent(() => import('@/pages/content/[detail]/index.vue'))
</script>
